import React from 'react';
import { Check } from 'lucide-react';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function FullCarDetailPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Full Car Detail',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Camarillo', 'Thousand Oaks', 'Ventura County', 'Los Angeles'],
    description: 'Complete mobile full car detailing service combining deep interior cleaning and premium exterior wash, clay bar, and wax protection.'
  };
  return <ServicePageLayout title="Full Car Detail in Los Angeles & Ventura County" subtitle="Our most popular package. A complete bumper-to-bumper transformation combining our premium interior and exterior detailing services." metaDescription="Get a complete full car detail in Camarillo, Thousand Oaks, and Ventura County. Mobile service includes interior deep clean and exterior wax. Call (818) 381-9905." schema={schema} data-id="element-319">
      <p data-id="element-320">
        If you want your vehicle to look and feel as close to brand new as
        possible, our <strong data-id="element-321">Full Car Detail</strong> is the ultimate solution.
        This comprehensive package combines the deep-cleaning power of our
        interior detailing with the protective, gloss-enhancing benefits of our
        exterior detailing. At Mike's Pro Detail, we provide top-tier mobile
        auto detailing in Camarillo CA, Thousand Oaks, and throughout Ventura
        County, bringing a complete automotive makeover directly to your
        driveway or workplace.
      </p>

      <h2 data-id="element-322">What's Included in a Full Detail?</h2>
      <p data-id="element-323">
        The Full Detail package leaves no stone unturned. We spend hours
        meticulously cleaning, restoring, and protecting every surface of your
        vehicle.
      </p>

      <h3 data-id="element-324">Exterior Services:</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-325">
        <li className="flex items-start" data-id="element-326">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-327" />
          <span data-id="element-328">
            <strong data-id="element-329">Scratch-Free Hand Wash:</strong> Two-bucket wash method to
            safely remove surface dirt and grime.
          </span>
        </li>
        <li className="flex items-start" data-id="element-330">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-331" />
          <span data-id="element-332">
            <strong data-id="element-333">Decontamination & Clay Bar:</strong> Removal of embedded
            iron particles, tree sap, and road tar to leave the paint smooth.
          </span>
        </li>
        <li className="flex items-start" data-id="element-334">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-335" />
          <span data-id="element-336">
            <strong data-id="element-337">Wheel & Tire Detail:</strong> Deep cleaning of wheel
            barrels, faces, and tires, finished with a premium no-sling
            dressing.
          </span>
        </li>
        <li className="flex items-start" data-id="element-338">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-339" />
          <span data-id="element-340">
            <strong data-id="element-341">Paint Protection:</strong> Application of a high-grade
            hybrid ceramic wax or sealant for months of gloss and UV protection.
          </span>
        </li>
      </ul>

      <h3 data-id="element-342">Interior Services:</h3>
      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-343">
        <li className="flex items-start" data-id="element-344">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-345" />
          <span data-id="element-346">
            <strong data-id="element-347">Deep Vacuuming & Extraction:</strong> Thorough removal of
            dirt and pet hair, followed by hot water extraction for carpets and
            cloth seats.
          </span>
        </li>
        <li className="flex items-start" data-id="element-348">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-349" />
          <span data-id="element-350">
            <strong data-id="element-351">Leather Treatment:</strong> Gentle cleaning and premium
            conditioning to restore softness and prevent cracking.
          </span>
        </li>
        <li className="flex items-start" data-id="element-352">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-353" />
          <span data-id="element-354">
            <strong data-id="element-355">Surface Sanitization:</strong> Steam cleaning of vents, cup
            holders, and dashboard to kill bacteria and remove sticky residues.
          </span>
        </li>
        <li className="flex items-start" data-id="element-356">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-357" />
          <span data-id="element-358">
            <strong data-id="element-359">Crystal Clear Glass:</strong> Streak-free cleaning of all
            interior and exterior windows and mirrors.
          </span>
        </li>
      </ul>

      <h2 data-id="element-360">The Ultimate Value and Convenience</h2>
      <p data-id="element-361">
        Booking a Full Car Detail is the most cost-effective way to completely
        reset your vehicle's condition. Whether you are preparing to sell your
        car, returning a lease, or simply want to fall in love with your daily
        driver all over again, this package delivers unmatched results. Plus,
        because we are a fully mobile operation, you don't have to waste your
        day sitting in a waiting room. We bring our own water and power,
        allowing you to continue working or relaxing at home while we transform
        your car.
      </p>

      <h2 data-id="element-362">Your Local Mobile Detailing Experts</h2>
      <p data-id="element-363">
        When residents search for "Car Detailing Camarillo" or "Mobile Detailing
        Ventura County", they consistently choose Mike's Pro Detail for our
        reliability, attention to detail, and exceptional customer service. From
        Calabasas to Moorpark, we are dedicated to providing the highest
        standard of mobile auto detailing available in Southern California.
      </p>
    </ServicePageLayout>;
}